import React from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import FormUserContact from './FormUserContact';
import Footer from '../../../shared/Footer';

const PreRegistration = () => (
    <div className="PreRegistration">
        <NavTagline />
        <section className="layout-container">
            <div className="container">
                <div className="descript-container container-2">
                    <div className="form-title g-clr">Almost Done!</div>
                    If you have an NPI (National Provider Identifier) number, enter the
                    10-digit identification number. Otherwise, enter the information below to complete the registration.
                </div>
                <FormUserContact />
            </div>
        </section>
        <Footer />
  </div>
);


export default PreRegistration;
